module.exports = __webpack_public_path__ + "fonts/SofiaProBold.0d3cb05b.woff";